import { Box, Container, Typography } from "@mui/material";
import React from "react";
import { heartt } from "../../assets/images";

const OurHeart = () => {
  return (
    <Box sx={{ width: "100vw" }}>
      <Container
        sx={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          textAlign: "center",
          backgroundImage: `url(${heartt})`,
          backgroundSize: "cover",
          backgroundRepeat: "no-repeat",
          backgroundPosition: "center",
          height: { md: "75vh" },
          my: {xs: 10, md: 0},
        }}
      >
        <Typography variant="h2">Our Heart</Typography>
 
          <Typography>
            The essence of EAGLE, who we are and what we do, is making
            connections that otherwise would not be possible. We want to provide
            the best resources and experiences to the least of those in
            communities we work in. We want to make a difference now that has an
            impact on generations and lasts for eternity. We are serious about
            having fun in all we do from the office to being in the field.
            Ultimately, we help others help others by acting as a connection
            point or hub between communities and service providers.
          </Typography>
      </Container>
    </Box>
  );
};

export default OurHeart;
